import {
  Breadcrumbs as MuiBreadcrumbs,
  Button as MuiButton,
  Card as MuiCard, Chip as MuiChip,
  Divider as MuiDivider,
  Drawer as MuiDrawer,
  FormControl as MuiFormControl,
  IconButton as MuiIconButton,
  Paper as MuiPaper,
  TextField as MuiTextField,
  Typography as MuiTypography,
} from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';
import { spacing } from '@mui/system';
import ReactPerfectScrollbar from 'react-perfect-scrollbar';
import styled, { css } from 'styled-components';
import {DRAWER_WIDTH, SMALL_DRAWER_WIDTH} from "../../models/consts";
import {SidebarCollapseType} from "../Sidebar/types";

export const IconButton = muiStyled(MuiIconButton)(spacing);
export const Button = muiStyled(MuiButton)(spacing);
export const Divider = muiStyled(MuiDivider)(spacing);
export const Typography = muiStyled(MuiTypography)(spacing);
export const Breadcrumbs = muiStyled(MuiBreadcrumbs)(spacing);
export const Card = muiStyled(MuiCard)(spacing);
export const Paper = muiStyled(MuiPaper)(spacing);
export const FormControl = muiStyled(MuiFormControl)<{ my?: number }>(spacing);
export const TextField = muiStyled(MuiTextField)<{ my?: number }>(spacing);

export const Root = styled.div<{isMobile: boolean}>`
  display: flex;
  gap: 18px;
  min-height: 100vh;
  padding: ${(props) => props.isMobile ? '0' : '24px' };
  box-sizing: border-box;
  background: #F8F9FA;
  //background: #6B7280;//for contrast bg
`;

export const DashboardDrawer = styled.div<{bigmenu: boolean, onClose: () => void}>`
  ${(props) => props.theme.breakpoints.up(768)} {
    height: calc(100vh - 48px);
    overflow: hidden;
    width: ${(props) => props.bigmenu ? `${DRAWER_WIDTH}px` : `${SMALL_DRAWER_WIDTH}px`};
    flex-shrink: 0;
    border-radius: 24px;
    transition: all .2s linear;
    + #platform-content {
      width: ${(props) => props.bigmenu ? `calc(100% - ${DRAWER_WIDTH}px)` : `calc(100% - ${SMALL_DRAWER_WIDTH}px)`};
    } 
  }
`;

export const SidebarDrawer = styled(MuiDrawer)`
  border-right: 0;

  > div {
    transition: all .2s linear;
    border-right: 0;
    z-index: 99;
  }
`;

const baseScrollbar = css`
  border-right: 1px solid rgba(0, 0, 0, 0.12);
  flex-grow: 1;
`;

export const Scrollbar = styled.div`
  ${baseScrollbar}
`;

export const PerfectScrollbar = styled(ReactPerfectScrollbar)`
  ${baseScrollbar}
`;

export const Items = styled.div<SidebarCollapseType>`
  //padding: 2px 24px;
  padding: ${(props) => props.isOpen ? `2px 24px` : `2px 12px`};
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
`;

export const AuthWrapper = styled(Paper)`
  padding: ${(props) => props.theme.spacing(3)};
  min-width: 400px;
  font-family: ${(props) => props.theme.typography.fontFamily};
  z-index: 99;
  ${(props) => props.theme.breakpoints.up('md')} {
    padding: ${(props) => props.theme.spacing(10)};
  }
  
  @media(max-width: 900px) {
    min-width: 300px;
  }
  
  @media(max-width: 767px) {
    width: 90%;
    min-width: 0 !important;
  }
`;

export const SmallButton = styled(Button)`
  padding: 4px;
  min-width: 0;

  svg {
    width: 0.9em;
    height: 0.9em;
  }
`;

export const MyRoot = styled.div`
  margin: 0 auto;
  justify-content: center;
  align-items: center;
  display: flex;
  min-height: 100vh;
  flex-direction: column;
`;

export const WhiteCard = styled.div`
  position: relative;
  padding: 24px;
  background: #FFFFFF;
  color: #111827;
  border: 0;
  border-radius: 24px;
  width: 100%;
  flex: auto;
`;

export const Chip = styled(MuiChip)`
  height: 24px;
  box-sizing: border-box;
  padding: 0;
  font-weight: 500;
  border-radius: 22px;
  text-transform: capitalize;
  font-size: 12px;
  text-align: center;

  span {
    height: 24px;
    padding-left: 2px;
    line-height: 22px;
  }
  &:not(.active-process, .inactive, .info)::before {
    content: '●';
    width: 16px;
    height: 18px;
    margin-left: 6px;
    font-size: 5px;
    line-height: 16px;
    min-width: 8px;
  }
  &.unpaid, &.process, &.warning {
    background-color: #F59E0B1A;
    color: #F59E0B;
    &.active-process {
      &::before {
        content: url('data:image/svg+xml,<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.00033 14.6665C11.6803 14.6665 14.667 11.6798 14.667 7.99984C14.667 4.31984 11.6803 1.33317 8.00033 1.33317C4.32033 1.33317 1.33366 4.31984 1.33366 7.99984" stroke="%23F59E0B" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/></svg>');
        width: 16px;
        height: 16px;
        margin-left: 8px;
        margin-right: 4px;
        animation: back-rotation 1.5s infinite linear;
        line-height: 14px;
      }
    }
  }

  &.active, &.success {
    background-color: #22C55E1A;
    color: #22C55E;
  }

  &.error {
    background-color: #EF44441A;
    color: #EF4444;
  }

  &.inactive, &.info {
    background-color: #EAECF0;
    color: #9ca0a7;
    padding-left: 8px;
  }
`;
